import { render, staticRenderFns } from "./EditTeamMember.vue?vue&type=template&id=0030d056&scoped=true&"
import script from "./EditTeamMember.vue?vue&type=script&lang=ts&"
export * from "./EditTeamMember.vue?vue&type=script&lang=ts&"
import style0 from "./EditTeamMember.vue?vue&type=style&index=0&id=0030d056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030d056",
  null
  
)

export default component.exports